export const API_LOGIN = "/auth/login";
export const API_LOGOUT = "/users/logout";

export const API_AUTH_SEND_AUTH_CODE = "/auth/send-auth-code";
export const API_AUTH_CHANGE_PASSWORD = "/auth/change-password";

export const API_CLIENT_CRASH = "/clients/crash";
export const API_ENUMS = "/enums";

export const API_USER = "/users";
export const API_USER_ME = "/users/me";
export const API_USER_CHANGE_PASSWORD = "/users/change-password";
export const API_USER_LIST = "/users/list";
export const API_USER_DISABLE = "/users/disable";
export const API_USER_ENABLE = "/users/enable";
export const API_USER_TREE = "/users/tree";

export const API_EMPLOYEE = "/employees";
export const API_EMPLOYEE_LIST = "/employees/list";
export const API_EMPLOYEE_TREE = "/employees/tree";

export const API_BUILDING = "/buildings";
export const API_BUILDING_LIST = "/buildings/list";
export const API_BUILDING_TREE = "/buildings/tree";

export const API_BILL = "/bills";
export const API_BILL_LIST = "/bills/list";
export const API_BILL_TREE = "/bills/tree";
export const API_BILL_FILTER_OPTIONS = "/bills/filter-options";

export const API_BILL_STATIS = "/bills/statis";
export const API_BILL_SIMPLE_STATIS = "/bills/simple-statis";

export const API_REVENUE_CATEGORY = "/categories/revenues";
export const API_REVENUE_CATEGORY_LIST = "/categories/revenues/list";

export const API_EXPENSE_CATEGORY = "/categories/expenses";
export const API_EXPENSE_CATEGORY_LIST = "/categories/expenses/list";

export const API_LIST_LAYOUT = "/list-layouts";

export const API_EXPORT_TASK_SYNC = "/exports/tasks/sync";

export const API_UPLOAD_ORG_LOGO = "/uploads/org-logo";

export const API_SETTING_ORG_INFO = "/settings/org-info";
export const API_SETTING_FEE_RULE = "/settings/fee-rule";

export const API_REMIND = "/reminds";
export const API_REMIND_TREE = "/reminds/tree";
export const API_REMIND_LIST = "/reminds/list";
export const API_REMIND_MY_LIST = "/reminds/my-list";
export const API_REMIND_READ = "/reminds/read";
export const API_REMIND_UN_READ_COUNTS = "/reminds/un-read-counts";

export const API_SYSTEM_LOG_LIST = "/system-logs/list";

export const API_OPENED_SYSTEM_INFO = "/opened/system-info";
export const API_OPENED_WEB_NOTICE = "/opened/web-notice";
export const API_OPENED_ORG_INFO = "/opened/org-info";
